"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CellularLite = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CellularLite = function CellularLite(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.default, props, /*#__PURE__*/React.createElement("path", {
    d: "M3 11H6V13H3V11Z",
    fill: "#0095E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9H11V13H8V9Z",
    fill: "#0095E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6H16V13H13V6Z",
    fill: "#0095E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3H21V13H18V3Z",
    fill: "#0095E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35265 19.8874H6.70726V21H3V15H4.35265V19.8874Z",
    fill: "#0095E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58705 21H8.23825V15H9.58705V21Z",
    fill: "#0095E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6847 16.1168H14.0006V21H12.648V16.1168H10.9947V15H15.6847V16.1168Z",
    fill: "#0095E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6069 18.4574H18.4797V19.8874H20.9923V21H17.127V15H21V16.1168H18.4797V17.3819H20.6069V18.4574Z",
    fill: "#0095E0"
  }));
};
exports.CellularLite = CellularLite;